<p-treeSelect
  #treeSelect
  class="w-full"
  [attr.styleClass]="styleClass"
  [appendTo]="appendTo"
  [options]="treeOptions()"
  [filter]="filter"
  [filterBy]="filterBy"
  [id]="id"
  [name]="name"
  [selectionMode]="selectionMode"
  [display]="selectionMode === 'single' ? 'comma' : 'chip'"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [emptyMessage]="emptyMessage"
  [ngModel]="value"
  [ngModelOptions]="ngModelOptions"
  [propagateSelectionDown]="true"
  [propagateSelectionUp]="true"
  [filterInputAutoFocus]="true"
  [resetFilterOnHide]="true"
  (ngModelChange)="onChange($event)"
  (onFilter)="handleFilter.emit($event)"
  (onShow)="handleFocus.emit($event)"
  (onHide)="handleHide.emit($event)"
  (onNodeSelect)="selectionMode === 'single' && treeSelect.hide()">
  <ng-template let-item pTemplate="default">
    <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ item }"></ng-container>
  </ng-template>
  <ng-template let-item pTemplate="node">
    <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ item }"></ng-container>
  </ng-template>
  <ng-template let-selectedItems let-placeholder="placeholder" pTemplate="value">
    <ng-container *ngIf="selectionMode === 'single'">
      <span class="text-gray-800">
        {{ selectedItems ? (selectedItems[optionLabel] | translate) : placeholder }}
      </span>
    </ng-container>
    <ng-container *ngIf="selectionMode === 'checkbox'">
      <div class="flex flex-wrap gap-2">
        <p-chip
          styleClass="p-chip-xs"
          *ngFor="let selectedItem of selectedItems"
          [label]="selectedItem[optionLabel]"
          [removable]="true"
          removeIcon="fa-regular fa-xmark"
          (onRemove)="onUnselectItem($event, selectedItem)"></p-chip>
      </div>
    </ng-container>
  </ng-template>
</p-treeSelect>

<ng-template #itemTemplate let-item="item">
  <div class="flex w-full items-center justify-between gap-2">
    <div class="flex flex-col items-start gap-1">
      <span class="flex items-center gap-2">
        {{ item[optionLabel] | translate }}
        <p-badge *ngIf="item?.count" [value]="item?.count" styleClass="p-badge-xs p-badge-gray"></p-badge>
      </span>
      <span *ngIf="item?.owner" class="overflow-hidden text-xs text-ellipsis whitespace-nowrap text-gray-600">{{
        'common.sharedby' | translate: { '0': item.owner }
      }}</span>
    </div>
    <div class="flex flex-row flex-nowrap">
      <p-chip
        *ngIf="item?.inactive"
        [label]="'management.users.inactive' | translate"
        styleClass="p-chip-xs p-chip-gray"></p-chip>
    </div>
  </div>
</ng-template>
